import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { cloneDeep, debounce } from 'lodash-es';
import { ToastService } from '../../../../../core/services/toast/toast.service';
import { UtilsService } from '../../../../../shared/utils/utils.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

interface ProductLink {
  product: string;
  url: string;
}

@Component({
    selector: 'app-modal-affiliate-links',
    imports: [MatDialogModule, MatFormFieldModule, MatInputModule, MatProgressSpinnerModule, MatIconModule, MatButtonModule],
    templateUrl: './modal-affiliate-links.component.html',
    styleUrl: './modal-affiliate-links.component.scss'
})
export class ModalAffiliateLinksComponent implements OnInit {
  fullname!: string;
  links!: Array<ProductLink>;
  filteredLinks!: Array<ProductLink>;
  isSearchingProduct = false;
  productToSearch = '';

  private debouncedSearchLink = debounce(() => {
    this.filterProduct();
  }, 1500);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ModalAffiliateLinksComponent>,
    private toast: ToastService,
    private utils: UtilsService
  ) {}

  ngOnInit(): void {
    const receivedData = this.data ? cloneDeep(this.data) : null;
    if (!receivedData.fullname || !receivedData.links) return this.closeModal();

    this.fullname = receivedData.fullname;
    this.links = receivedData.links;
    this.filteredLinks = cloneDeep(this.links);
  }

  closeModal(result?: any): void {
    this.dialogRef.close(result);
  }

  copyProductUrl(url: string): void {
    navigator.clipboard.writeText(url);
    this.toast.presentSuccessToast(`Copiado: ${url}`, 5000);
  }

  filterProductDebounced(event: any): void {
    this.productToSearch = event?.target?.value ? event.target.value.trim().toLowerCase() : null;
    if (!this.utils.hasSomething(this.productToSearch)) {
      this.isSearchingProduct = false;
      this.filteredLinks = cloneDeep(this.links);
      return;
    }

    this.isSearchingProduct = true;
    this.debouncedSearchLink();
  }

  filterProduct(): void {
    let linksCopy: Array<ProductLink> = cloneDeep(this.links);
    linksCopy = linksCopy.filter((productLink) => productLink.product.toLowerCase().includes(this.productToSearch));
    this.filteredLinks = linksCopy;
    this.isSearchingProduct = false;
  }
}
